import { useState } from 'react'
import { Button, Flex, Modal, Popconfirm, Typography } from 'antd'
import { isNull } from 'lodash'
import { Wallet } from 'src/views/widgets/walletCard/types'
import {
  submitArchive,
  submitUnArchive,
} from 'src/pages/finSystem/wallets/atoms/DangerZone/model'

type Props = {
  wallet: Wallet
}

export const DangerZone = ({ wallet }: Props) => {
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const { Text } = Typography

  const isActive = isNull(wallet.archivedAt)

  const handleConfirm = () => {
    if (!isActive) {
      submitUnArchive({ idWallet: wallet.id })
      return
    }
    if (wallet.overallBalanceUsd === 0) {
      submitArchive({ idWallet: wallet.id })
      return
    }
    setIsOpenAlertModal(true)
  }

  const handleCancel = () => setIsOpenAlertModal(false)

  return (
    <Flex align="end" vertical>
      <Popconfirm
        title={isActive ? 'Archive wallet' : 'Unarchive wallet'}
        description={`Are you sure to ${
          isActive ? 'archive' : 'unarchive'
        }  wallet?`}
        okText="Yes"
        cancelText="No"
        onConfirm={handleConfirm}
      >
        <Button color="red" variant="solid">
          {isActive ? 'Archive wallet' : 'Unarchive wallet'}
        </Button>
      </Popconfirm>
      <Modal
        title={<div style={{ fontSize: 20 }}>Cannot Archive Wallet</div>}
        centered
        wrapClassName="ant_modal"
        width={400}
        maskClosable={false}
        open={isOpenAlertModal}
        onCancel={handleCancel}
        footer={[
          <Button key="ok" type="primary" onClick={handleCancel}>
            OK
          </Button>,
        ]}
      >
        <Text style={{ fontSize: 16 }}>
          This wallet currently has a balance of {wallet.overallBalanceUsd}{' '}
          <Text style={{ fontSize: 16 }} type="secondary">
            USD
          </Text>
          . Please withdraw or zero the balance before archiving it.
        </Text>
      </Modal>
    </Flex>
  )
}
